import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FolderIcon from '@mui/icons-material/Folder';
import BugReportIcon from '@mui/icons-material/BugReport';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { projectActions } from '../../store';

export const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myProfile = useSelector((state) => state.auth.myProfile);
  const projects = useSelector((state) => state.projects.projects);

  useEffect(() => {
    dispatch(projectActions.getProjects());
  }, [dispatch]);

  const summaryCards = [
    {
      title: 'Projects',
      value: projects?.length || 0,
      icon: <FolderIcon sx={{ fontSize: 40 }} />,
      color: 'primary.main',
      bgColor: 'action.selected',
    },
    {
      title: 'My Tasks',
      value: '--',
      icon: <AssignmentIcon sx={{ fontSize: 40 }} />,
      color: 'secondary.main',
      bgColor: 'action.focus',
    },
    {
      title: 'Bugs',
      value: '--',
      icon: <BugReportIcon sx={{ fontSize: 40 }} />,
      color: 'error.main',
      bgColor: 'action.hover',
    },
    {
      title: 'Completed',
      value: '--',
      icon: <CheckCircleIcon sx={{ fontSize: 40 }} />,
      color: 'success.main',
      bgColor: 'action.hover',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
        Dashboard
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        Welcome back{myProfile?.name ? `, ${myProfile.name}` : ''}
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        {summaryCards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.title}>
            <Card
              elevation={0}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: card.bgColor,
                    color: card.color,
                    display: 'flex',
                  }}
                >
                  {card.icon}
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    {card.value}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {card.title}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
        Recent Projects
      </Typography>
      <Grid container spacing={2}>
        {projects?.slice(0, 6).map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project._id}>
            <Card
              elevation={0}
              sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}
            >
              <CardActionArea onClick={() => navigate(`/projects/${project._id}/board`)}>
                <CardContent>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {project.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600 }}>
                    {project.key}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', mt: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    {project.description || 'No description'}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
